import { getEnv } from "#app/lib/env";

/**
 * The API service base URLs, resolved from env once — the single home for
 * these env keys and their localhost defaults. Every service exposes
 * unauthenticated REST `GET /health` and `GET /version` off its base (see
 * each service's main.ts); GraphQL endpoints hang off the same bases.
 */
export const CORE_API_BASE = getEnv(
  "EXPO_PUBLIC_CORE_API",
  "http://localhost:3000",
);

export const AUTH_API_BASE = getEnv(
  "EXPO_PUBLIC_LOGIN_URL",
  "http://localhost:3001",
);

/** The flags env var points at the service's GraphQL endpoint, not its root. */
export const FEATURE_FLAGS_GRAPHQL_URL = getEnv(
  "EXPO_PUBLIC_FLAGS_API",
  "http://localhost:3002/graphql",
);

export const ANALYTICS_API_BASE = getEnv(
  "EXPO_PUBLIC_ANALYTICS_API",
  "http://localhost:3003",
);
